module.exports = __webpack_public_path__ + "static/img/top1-img.f52ccba.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top1-img.png
// module id = wf40
// module chunks = 1